import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { BranchDeliverySettingFilterEntity } from '../../domain/entities/BranchDeliverySettingFilterEntity'

export class BranchDeliverySettingFilterModel extends BranchDeliverySettingFilterEntity {
  constructor(dataDto: BranchDeliverySettingFilterEntity) {
    super()
    mapEntityProperties<BranchDeliverySettingFilterModel>(this, dataDto)
  }
}
